/**
 * Created by fanglijuan 2017-5-19
 */
angular.module("mangeProNewsPaperDistributeConfigCtrlModule",[])
    .controller("mangeProNewsPaperDistributeConfigAddCtrl", ["$scope", "$modalInstance","title",'successFn',function ($scope, $modalInstance,title,successFn) {
        initData();
        $scope.cancel = function () {
            $scope.$close();
        };
        $scope.confirm = function () {
            $modalInstance.close({});
        };
        function initData(){
            $scope.title = title;
            $scope.successFn = successFn;
        }
    }]);